import ProgressiveImage from './ProgressiveImage';

export default ProgressiveImage;



// WEBPACK FOOTER //
// ./src/components/common/ProgressiveImage/index.js